__turbopack_context__.v({
  "error_msg": "_FormMessage-module-scss-module__JN575a__error_msg",
  "helper_msg": "_FormMessage-module-scss-module__JN575a__helper_msg",
});
